import { render, staticRenderFns } from "./TestQuestionList.vue?vue&type=template&id=1fdd8a78&scoped=true"
import script from "./TestQuestionList.vue?vue&type=script&lang=js"
export * from "./TestQuestionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd8a78",
  null
  
)

export default component.exports